/**
 * Date figée du déploiement.
 *
 * `process.env.NEXT_PUBLIC_BUILD_TIME` est injectée par next.config.mjs
 * au moment du build via `define`. Sur le serveur SSR ET sur le client
 * hydraté, la valeur est strictement la même (string statique inlinée
 * dans le bundle), ce qui élimine la classe d'erreurs React #418
 * (Hydration: Text content does not match server-rendered HTML)
 * causée par `new Date()` appelé à chaque render.
 *
 * Fallback `BUILD_FALLBACK` pour le mode dev où la variable n'est pas
 * encore set : on prend la date du module load — en dev, SSR et client
 * tournent sur la même process node donc pas de mismatch.
 */
const BUILD_FALLBACK = "2026-05-02T00:00:00.000Z"
const buildIso =
  process.env.NEXT_PUBLIC_BUILD_TIME && process.env.NEXT_PUBLIC_BUILD_TIME !== ""
    ? process.env.NEXT_PUBLIC_BUILD_TIME
    : BUILD_FALLBACK
const buildDate = new Date(buildIso)

export const BUILD_DATE_ISO = buildDate.toISOString().slice(0, 10)

export const BUILD_DATE_FR = buildDate.toLocaleDateString("fr-FR", {
  day: "numeric",
  month: "long",
  year: "numeric",
  timeZone: "Europe/Paris",
})

export const BUILD_YEAR = buildDate.toLocaleDateString("fr-FR", {
  year: "numeric",
  timeZone: "Europe/Paris",
})

/** Années écoulées depuis la création d'ADIS 95 (1986). */
export const YEARS_SINCE_FOUNDING = buildDate.getFullYear() - 1986
